"use strict";
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});





let navTriggers = document.querySelectorAll(".nav__item");
for (let navTrigger of navTriggers) {
  navTrigger.addEventListener("click", (event) => {
    let activeClass = document.querySelector(".nav__item--active");
    if (activeClass) {
      activeClass.classList.remove("nav__item--active");
    }
    event.currentTarget.classList.add("nav__item--active");
  });
}



// const sections = document.querySelectorAll("section");
// const navLi = document.querySelectorAll("nav ul li");


// window.addEventListener("scroll", () => {
//     const current = "";
    
//     sections.forEach(section => {
//         const sectionTop = section.offsetTop;
//         const sectionHeight = section.clientHeight;

//         if(pageYOffset > sectionTop){
//             current = section.getAttribute("id");
//         }
//     })

//     navLi.forEach(li => {
//         li.classList.remove(".nav__item--active");
//         if(li.classList.contains(current)){
//             li.classList.add(".nav__item--active")
//         }
//     })

// })
